module.exports = __webpack_public_path__ + "static/img/SI.0189fe07.svg";